import { Link } from "react-router-dom";
import { Leaf, Mail, Phone, Instagram, Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-sage-100 text-ink-900 mt-10 overflow-hidden"
    >
      <div aria-hidden className="absolute -top-20 -left-20 w-[380px] h-[380px] rounded-full bg-honey-200/40 blur-3xl" />
      <div aria-hidden className="absolute -bottom-20 -right-20 w-[380px] h-[380px] rounded-full bg-clay-200/40 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-10 h-10 rounded-full bg-sage-400 text-bone-50 flex items-center justify-center">
                <Leaf strokeWidth={1.75} className="w-4 h-4" />
              </span>
              <span className="font-display text-2xl">
                Xenia <span className="italic text-sage-600">Höfel</span>
              </span>
            </div>
            <p className="mt-6 max-w-sm text-ink-700 leading-relaxed">
              Ganzheitliche Begleitung in Gesundheit &amp; Finanzen — ruhig, ehrlich und an deiner Seite.
            </p>

            <div className="mt-8 flex items-center gap-3">
              <a
                href="#"
                data-testid="footer-social-instagram"
                className="w-11 h-11 rounded-full bg-clay-200 hover:bg-clay-300 text-clay-600 flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram strokeWidth={1.75} className="w-4 h-4" />
              </a>
              <a
                href="mailto:beratung@xeniahoefel.de"
                data-testid="footer-social-mail"
                className="w-11 h-11 rounded-full bg-sage-200 hover:bg-sage-300 text-sage-700 flex items-center justify-center transition-colors"
                aria-label="Mail"
              >
                <Mail strokeWidth={1.75} className="w-4 h-4" />
              </a>
              <a
                href="tel:+4915156166703"
                data-testid="footer-social-phone"
                className="w-11 h-11 rounded-full bg-honey-200 hover:bg-honey-300 text-honey-600 flex items-center justify-center transition-colors"
                aria-label="Phone"
              >
                <Phone strokeWidth={1.75} className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-fine text-[11px] tracking-[0.22em] uppercase text-sage-600">
              Navigation
            </div>
            <ul className="mt-5 space-y-3 text-[15px] text-ink-700">
              <li><a href="/gesundheit" className="hover:text-sage-600 transition-colors">Gesundheit</a></li>
              <li><a href="/finanzen" className="hover:text-sage-600 transition-colors">Finanzen</a></li>
              <li><a href="/ueber-mich" className="hover:text-sage-600 transition-colors">Über mich</a></li>
              <li><a href="/kontakt" className="hover:text-sage-600 transition-colors">Kontakt</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono-fine text-[11px] tracking-[0.22em] uppercase text-sage-600">
              Kontakt
            </div>
            <ul className="mt-5 space-y-3 text-[15px] text-ink-700">
              <li>beratung@xeniahoefel.de</li>
              <li>+49 151 56166703</li>
              <li>Montag – Freitag · 9:00 – 18:00 Uhr</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-sage-300/50 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[13px] text-ink-500">
          <div className="flex items-center gap-2">
            Gemacht mit <Heart strokeWidth={1.75} className="w-3.5 h-3.5 text-clay-400 fill-clay-400" /> für Xenia · © {new Date().getFullYear()}
          </div>
          <div className="flex items-center gap-6">
            <Link to="/impressum" className="hover:text-sage-700 transition-colors" data-testid="footer-link-impressum">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-sage-700 transition-colors" data-testid="footer-link-datenschutz">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
